import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { Shield, Lock, Home } from 'lucide-react';
import { StepIndicator } from './StepIndicator';

export function TeamALayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col">
      <header className="sticky top-0 z-10 border-b border-slate-200 bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-3">
          <Link to="/" className="flex items-center gap-2 text-base font-semibold text-teamA-primary">
            <Shield className="h-5 w-5" />
            <span>小物归队</span>
          </Link>
          <div className="flex items-center gap-2">
            <span className="hidden text-xs text-teamA-primary sm:inline">
              A 队 · 张翰天 · 肖淑慧 · 高宇棋
            </span>
            <Link
              to="/"
              aria-label="返回主页"
              title="返回主页(失物墙)"
              className="flex h-9 w-9 items-center justify-center rounded-md text-teamA-primary transition hover:bg-teamA-primary/10"
            >
              <Home className="h-5 w-5" />
            </Link>
          </div>
        </div>
      </header>
      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-4">
        <StepIndicator />
        {children}
      </main>
      <footer className="border-t border-slate-200 bg-white py-3 text-center text-xs text-slate-400">
        <div className="flex items-center justify-center gap-1">
          <Lock className="h-3 w-3" />
          <span>基于同学互助与诚信使用 · 请只领取自己的物品</span>
        </div>
        <div className="mt-1">2026 · AI 智能体开发专项赛 · 小物归队</div>
      </footer>
    </div>
  );
}
